const getPersonDisplayName = (person) =>
  (person?.full_name ||
    `${person?.first_name || ""} ${person?.last_name || ""}`).trim();

export const isEmployerRoleUser = (
  person,
  { fromEmployerOnlyApi = false, roles = [] } = {}
) => {
  if (fromEmployerOnlyApi) return true;

  const nestedRoleName = person?.user_type?.role_name;
  if (nestedRoleName && nestedRoleName.toLowerCase() === "employer") {
    return true;
  }

  if (person?.user_type != null && roles.length > 0) {
    const employerRole = roles.find(
      (role) => role.role_name?.toLowerCase() === "employer"
    );
    if (employerRole && String(person.user_type) === String(employerRole.id)) {
      return true;
    }
  }

  return false;
};

export const formatReportingManagerLabel = (person, options = {}) => {
  const name = getPersonDisplayName(person);
  const employeeId = (person?.employee_id || "").toString().trim();
  const isEmployer = isEmployerRoleUser(person, options);
  const orgAdminSuffix = isEmployer ? " (org admin)" : "";

  if (employeeId) {
    return `${employeeId} - ${name}${orgAdminSuffix}`;
  }

  return `${name}${orgAdminSuffix}`;
};

export const buildReportingManagerOptions = (
  people,
  { fromEmployerOnlyApi = false, roles = [] } = {}
) => {
  const uniquePeople = Array.from(
    new Map((people || []).map((person) => [person.id, person])).values()
  );

  return uniquePeople.map((person) => ({
    label: formatReportingManagerLabel(person, { fromEmployerOnlyApi, roles }),
    value: person.id,
  }));
};
